import { MenuMode, useMenuContext } from "Components";
import styled, { css } from "styled-components";
import { AppLinks } from "./AppLinks";
import { ArtistGroup } from "./ArtistGroup";
import { NavLinks } from "./NavLinks";
import { Teammates } from "./Teammates";
import { AppSecondaryLinks } from "./AppSecondaryLinks";
import { useMenuBarHeight } from "hooks/useMenuBarHeight";

export const SideBar = () => {
  const { menuMode } = useMenuContext();
  const { menuBarHeight } = useMenuBarHeight();

  return (
    <Container menuMode={menuMode} menuBarHeight={menuBarHeight}>
      <ArtistGroup />
      <NavLinks />
      <AppLinks />
      <AppSecondaryLinks />
      {menuMode === "expanded" && <Teammates />}
    </Container>
  );
};

interface ContainerProps {
  menuMode: MenuMode;
  menuBarHeight: number;
}

const Container = styled.div<ContainerProps>(
  ({ menuMode, menuBarHeight }) => {
    return css`
      width: 25vw;
      flex-shrink: 0;
      box-shadow: inset -1px 0 0 0 var(--box-shadow-color);
      z-index: 15;
      background: #fff;
      transition: 300ms ease;

      ${({ theme }) => theme.media.desktop} {
        max-width: ${menuMode === "expanded" ? "350px" : "85px"};
        min-width: ${menuMode === "expanded" ? "270px" : "85px"};
      }
      ${({ theme }) => theme.media.mobile} {
        position: fixed;
        top: ${menuBarHeight}px;
        bottom: 0;
        left: 0;
        width: 100%;
        transform: ${menuMode === "expanded" ? "" : "translateX(-100%)"};
        transition: transform ease-in-out 100ms;
        overflow: auto;
      }

      @media (min-width: 1120px) {
        position: unset;
        transform: none;
        //max-width: 22%;
      }
    `;
  },
  ({ theme }) => {
    if (!theme.custom) return null;
    const { background, color } = theme.custom.layout.sideBar;
    return css`
      background: ${background};
      color: ${color};
    `;
  },
);
